import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { Mail } from 'lucide-react'

// The nav's DMs item: PrivateIcon's frame with the mail glyph.
export default function DirectMessagesIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div className={cn(styles.iconComp, contextStyles, hoverStyles, selectedStyles)}>
            <Mail />
        </div>
    )
}
